<template>
  <div class="model" v-if="visible">
    <div class="cookie-wall dark">
      <div v-html="$t('cookie_wall.statement_text', { link: `https://policies.nuwarobotics.com/${getLangCode}/privacy.html`})"></div>
      <div class="button-group">
        <button @click="agree" class="agree btn">
          {{ $t("cookie_wall.agree_use_cookie") }}
        </button>
        <button @click="disagree" class="disagree btn">
          {{ $t("cookie_wall.disagree_use_cookie") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/service/config.js";
import Cookies from "cookiejs";
const cookieDomain = process.env.VUE_APP_cookie_domain;
export default {
  name: "cookie-wall",
  props: {
    theme: {
      //主题色 light/dark
      type: String,
      default: "light",
    },
    prefix: String, //储存key前缀,一般是工具名称
    userId: String, //用户id，用于拼接储存key
    // redirectUrl: "", // 不同意隐私政策的重定向地址
  },
  data() {
    return {
      visible: false, //是否可见
    };
  },
  computed: {
    privacyMarkerKey() {
      if (!this.userId) {
        return "";
      }
      return `pravicy-${this.prefix}-${this.userId}`;
    },
    getLangCode() {
      let langCode = this.util$.getCookie$("langCode");
      return langCode.toLowerCase();
    },
  },
  mounted() {
    this.$nextTick(() => {
      const privacyMarker =
        window.localStorage.getItem(this.privacyMarkerKey) || null;
      if (privacyMarker !== "true" && privacyMarker !== true) {
        this.visible = true;
      }
    });
  },
  methods: {
    // 同意
    agree() {
      window.localStorage.setItem(this.privacyMarkerKey, "true");
      this.visible = false;
    },
    // 不同意
    disagree() {
      //清除所有cookie跳转到登陆页面 window.location.href = systemConfig.accountCenterUrl
      this.clearAllCookies();
      const { httpProtocol, userCenterUrl } = config;
      let redirectUrl = httpProtocol + "//" + userCenterUrl;
      if (this.currentVersion !== "student") {
        redirectUrl += "/login";
      }
      redirectUrl += "?redirect=" + window.location.href.split("?")[0];
      window.location.href = redirectUrl;
    },
    clearAllCookies() {
      Object.keys(Cookies()).forEach((cookieName) => {
        Cookies.set(cookieName, "", {
          domain: cookieDomain,
          path: "/",
          expires: -1,
        });
      });
    },
  },
};
</script>
<style lang="scss">
html {
  font-size: 1px !important;
}
.model {
  background: rgba($color: #fff, $alpha: 0.5);
  position: fixed;
  left: 0;
  top: 60rem;
  height: 100%;
  width: 100%;
  z-index: 2000;
  .cookie-wall {
    width: 100%;
    padding: 20rem 90rem;
    border-top: 1rem solid change-color(#00b5e2, $alpha: 0.5);
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9999;
    font-size: 14rem;
    color: #333;
    line-height: 1.5em;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    a{
        color: #00b5e2;
        text-decoration: underline;
    }
    & > div {
      flex: 1 1 auto;
    }
    .button-group {
      margin-left: 28rem;
      white-space: nowrap;
      .agree {
        background: rgba(0, 181, 226, 0.1);
        color: #00b5e2;
        border: 1rem solid #00b5e2;
        &:hover {
          background: #00b5e2;
          color: #fff;
        }
      }
      .disagree {
        background: #fff;
        color: #666;
        border: 1.5rem solid rgba(51, 51, 51, 0.5);
        &:hover {
          background: rgba(0, 181, 226, 0.1);
          color: #00b5e2;
        }
      }
      .btn {
        padding: 12rem 14rem;
        margin-left: 14rem;
        border-radius: 6rem;
        outline: none;
        cursor: pointer;
      }
    }
    &.dark {
      background: #000;
      color: #fff;
      a {
        color: #fff;
        text-decoration: underline;
      }
    }
  }
}
</style>